import { render, staticRenderFns } from "./chooseSelf.vue?vue&type=template&id=47573dca&scoped=true&"
import script from "./chooseSelf.vue?vue&type=script&lang=js&"
export * from "./chooseSelf.vue?vue&type=script&lang=js&"
import style0 from "./chooseSelf.vue?vue&type=style&index=0&id=47573dca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47573dca",
  null
  
)

export default component.exports